import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-svg2",
  "use": "vab-icon-svg2-usage",
  "viewBox": "0 0 14 10",
  "content": "<symbol viewBox=\"0 0 14 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-svg2\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.1281 0.643019C13.3884 0.903366 13.3884 1.32548 13.1281 1.58583L5.63272 9.08119C5.34633 9.36752 4.88201 9.36752 4.59562 9.08119L0.87153 5.35705C0.611183 5.09672 0.611183 4.67459 0.87153 4.41425C1.13188 4.15392 1.55399 4.15392 1.81434 4.41425L5.11417 7.71405L12.1853 0.643019C12.4456 0.382666 12.8677 0.382666 13.1281 0.643019Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol